"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectGridWithActions = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("@veeam/components");
const Up_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/common/Up/Up.svg"));
const Down_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/common/Down/Down.svg"));
require("./types");
const SelectGrid_1 = require("./SelectGrid");
function SelectGridWithActions({ renderAvailableContent, renderChosenContent, availableData, chosenData, idKey, displayField, addText, removeText, upText, downText, loading, onChange, rowHeight, cellRenderer, isRowDisabled, subheaderRenderer, cellRendererFn, cellRendererWithSearch, }) {
    const [searchValue, setSearchValue] = react_1.useState('');
    const filterAvailable = (newSearchValue, dataState, setDataState) => {
        const search = newSearchValue.toLowerCase();
        const chosenIds = dataState.chosenData.map((item) => item[idKey]);
        const filteredData = availableData
            .filter((item) => (cellRendererFn ? cellRendererFn(item) : item[displayField])
            .toLowerCase()
            .indexOf(search) !== -1)
            .filter((item) => chosenIds.indexOf(item[idKey]) === -1);
        setDataState((prevState) => ({
            availableData: filteredData,
            selectedAvailableData: [],
            chosenData: prevState.chosenData,
            selectedChosenData: prevState.selectedChosenData,
        }));
    };
    return (react_1.default.createElement(SelectGrid_1.SelectGrid, { renderAvailableContent: renderAvailableContent, renderChosenContent: renderChosenContent, availableData: availableData, chosenData: chosenData, idKey: idKey, displayField: displayField, sortChosen: false, addText: addText, removeText: removeText, onAdd: ({ chosenItems }) => onChange === null || onChange === void 0 ? void 0 : onChange({ chosenItems }), onRemove: ({ chosenItems }) => onChange === null || onChange === void 0 ? void 0 : onChange({ chosenItems }), loading: loading, rowHeight: rowHeight, cellRenderer: cellRenderer, cellRendererWithSearch: cellRendererWithSearch === null || cellRendererWithSearch === void 0 ? void 0 : cellRendererWithSearch(searchValue), isRowDisabled: isRowDisabled, subheaderRenderer: subheaderRenderer, searchRenderer: (dataState, setDataState) => {
            return (react_1.default.createElement(components_1.Search, { value: searchValue, onChange: (newValue) => {
                    filterAvailable(newValue, dataState, setDataState);
                    setSearchValue(newValue);
                }, onSearch: () => filterAvailable(searchValue, dataState, setDataState), size: components_1.CONTROL_SIZE.full }));
        }, actionsRenderer: ({ selectedChosenData, chosenData: chosenDataItems }, setDataState) => {
            var _a, _b;
            const disabled = !selectedChosenData.length || selectedChosenData.length > 1;
            const firstSelected = selectedChosenData[0];
            const disabledUp = (firstSelected === null || firstSelected === void 0 ? void 0 : firstSelected[idKey]) === ((_a = chosenDataItems[0]) === null || _a === void 0 ? void 0 : _a[idKey]);
            const disabledDown = (firstSelected === null || firstSelected === void 0 ? void 0 : firstSelected[idKey]) === ((_b = chosenDataItems[chosenDataItems.length - 1]) === null || _b === void 0 ? void 0 : _b[idKey]);
            const onClickHandler = (newIndexFn) => () => {
                const chosenIds = chosenDataItems.map((item) => item[idKey]);
                const index = chosenIds.indexOf(firstSelected[idKey]);
                const records = chosenDataItems.splice(index, 1);
                chosenDataItems.splice(newIndexFn(index), 0, records[0]);
                setDataState((prevState) => ({
                    availableData: prevState.availableData,
                    selectedAvailableData: prevState.selectedAvailableData,
                    chosenData: [...chosenDataItems],
                    selectedChosenData: prevState.selectedChosenData,
                }));
                onChange === null || onChange === void 0 ? void 0 : onChange({ chosenItems: chosenDataItems });
            };
            return (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, gap: components_1.STACK_GAP.l },
                react_1.default.createElement(components_1.Button, { disabled: disabled || disabledUp, ui: components_1.BUTTON_VIEW.text, onClick: onClickHandler((index) => index - 1) },
                    react_1.default.createElement(components_1.Icon, { src: Up_svg_1.default }),
                    upText),
                react_1.default.createElement(components_1.Button, { disabled: disabled || disabledDown, ui: components_1.BUTTON_VIEW.text, onClick: onClickHandler((index) => index + 1) },
                    react_1.default.createElement(components_1.Icon, { src: Down_svg_1.default }),
                    downText)));
        } }));
}
exports.SelectGridWithActions = SelectGridWithActions;
SelectGridWithActions.displayName = 'SelectGridWithActions';
//# sourceMappingURL=SelectGridWithActions.js.map